/**
 * @file useCreateUpload.ts
 * @author markJia(markjia@tencent.com)
 */
import { Upload } from '@tencent/glue-model-upload';
import { useRefCallback, useSingleton } from '@tencent/glue-react-use';
import { useEffect } from 'react';
export var useCreateUpload = function useCreateUpload(props) {
  var onChange = props.onChange,
      onProgress = props.onProgress,
      _props$value = props.value,
      value = _props$value === void 0 ? [] : _props$value,
      _props$accept = props.accept,
      accept = _props$accept === void 0 ? '*/*' : _props$accept,
      _props$maxCount = props.maxCount,
      maxCount = _props$maxCount === void 0 ? -1 : _props$maxCount,
      _props$isDisabled = props.isDisabled,
      isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
      _props$isReadonly = props.isReadonly,
      isReadonly = _props$isReadonly === void 0 ? false : _props$isReadonly,
      requestConfig = props.requestConfig,
      _props$isMultiple = props.isMultiple,
      isMultiple = _props$isMultiple === void 0 ? false : _props$isMultiple,
      beforeUpload = props.beforeUpload;
  var upload = useSingleton(function () {
    return new Upload();
  });
  var changeHandle = useRefCallback(onChange);
  var progressHandle = useRefCallback(onProgress);
  upload.updateOptions({
    accept: accept,
    requestConfig: requestConfig,
    isReadonly: isReadonly,
    isDisabled: isDisabled,
    maxCount: maxCount,
    value: value,
    isMultiple: isMultiple,
    beforeUpload: beforeUpload
  });
  useEffect(function () {
    upload.addListener('upload-change', changeHandle);
    upload.addListener('progress-change', progressHandle);
    return function () {
      upload.removeListener('upload-change', changeHandle);
      upload.removeListener('progress-change', progressHandle);
    };
  }, []);
  return upload;
};